import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoginForm from './auth/Login';

// Blurs/dims the current page rather than replacing it, so a form the user
// was mid-way through is still there once they unlock -- matches Clinical
// Outcomes' screen-lock behavior. Mounted as a sibling of the router in
// App.tsx so it renders above whichever route is currently active.
const SessionLockOverlay: React.FC = () => {
  const { sessionLocked } = useAuth();

  if (!sessionLocked) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-base-300/35 p-4 backdrop-blur-xl">
      <div className="w-full max-w-md">
        <div className="mb-3 rounded-box border border-warning bg-warning/15 p-3 text-center text-sm text-base-content">
          We have locked your screen to maintain privacy. To unlock your screen, re-enter your credentials.
        </div>
        <LoginForm embedded onLoginSuccess={() => undefined} />
      </div>
    </div>
  );
};

export default SessionLockOverlay;
